module.exports = __webpack_public_path__ + "img/attachment.39cc30c2.png";